export const FETCH_CONNECTOR_LOGS = 'FETCH_CONNECTOR_LOGS'
export const FETCH_CONNECTOR_LOGS_SUCCESS = `${FETCH_CONNECTOR_LOGS}_SUCCESS`
export const FETCH_CONNECTOR_LOGS_RESET = `${FETCH_CONNECTOR_LOGS}_RESET`

export const FETCH_CUSTOM_CONNECTOR_INSTANCE = 'space/connector/custom/FETCH'
export const FETCH_CUSTOM_CONNECTOR_INSTANCE_SUCCESS = `${FETCH_CUSTOM_CONNECTOR_INSTANCE}_SUCCESS`
export const FETCH_CUSTOM_CONNECTOR_INSTANCE_RESET = `${FETCH_CUSTOM_CONNECTOR_INSTANCE}_RESET`
